__turbopack_context__.v({
  "accent": "Logo-module-scss-module__23_uaW__accent",
  "ai": "Logo-module-scss-module__23_uaW__ai",
  "c": "Logo-module-scss-module__23_uaW__c",
  "christmas": "Logo-module-scss-module__23_uaW__christmas",
  "deer": "Logo-module-scss-module__23_uaW__deer",
  "flyOver": "Logo-module-scss-module__23_uaW__flyOver",
  "glow": "Logo-module-scss-module__23_uaW__glow",
  "halloween": "Logo-module-scss-module__23_uaW__halloween",
  "hat": "Logo-module-scss-module__23_uaW__hat",
  "ivit": "Logo-module-scss-module__23_uaW__ivit",
  "liveNow": "Logo-module-scss-module__23_uaW__liveNow",
  "logo": "Logo-module-scss-module__23_uaW__logo",
  "nose": "Logo-module-scss-module__23_uaW__nose",
  "peekOut": "Logo-module-scss-module__23_uaW__peekOut",
  "peekOutDeer": "Logo-module-scss-module__23_uaW__peekOutDeer",
  "prance": "Logo-module-scss-module__23_uaW__prance",
  "pride": "Logo-module-scss-module__23_uaW__pride",
  "stpatty": "Logo-module-scss-module__23_uaW__stpatty",
  "svg": "Logo-module-scss-module__23_uaW__svg",
  "twinkle": "Logo-module-scss-module__23_uaW__twinkle",
});
